var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    class: (_class = {}, _class[_vm.$style.scrollerArrow] = true, _class[_vm.$style.disabled] = !_vm.canClickLeft, _class),
    attrs: {
      "data-scroller-selector-back": ""
    },
    on: {
      "click": _vm.scrollBack
    }
  }), _vm._t("default", null, {
    "currentScrollerItem": _vm.currentScrollerItem
  }), _c('div', {
    class: (_class2 = {}, _class2[_vm.$style.scrollerArrow] = true, _class2[_vm.$style.disabled] = !_vm.canClickRight, _class2[_vm.$style.right] = true, _class2),
    attrs: {
      "data-scroller-selector-forward": ""
    },
    on: {
      "click": _vm.scrollForward
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }